<template>
  <div class="qm-picture-library">
    <el-dialog
      v-if="viewType === 'dialog'"
      title=""
      :append-to-body="appendToBody"
      :close-on-click-modal="false"
      :visible="visible"
      @close="closeDialog"
      custom-class="qm-picture-library-dialog"
    >
      <Panel v-bind="$attrs" v-on="$listeners" :appendToBody="appendToBody" :visible="visible" />
    </el-dialog>
    <Panel
      v-else-if="viewType === 'panel'"
      class="qm-picture-library-panel"
      v-bind="$attrs"
      v-on="$listeners"
      :appendToBody="appendToBody"
      :visible="true"
      :showInsertBtn="false"
    />
  </div>
</template>

<script>
import * as api from './api'
import Panel from './panel.vue'

export default {
  name: 'QmPictureLibrary',
  props: {
    // 展示形态
    viewType: {
      type: String,
      default: 'dialog',
    },
    // 为了解决遮罩层会在最上面 在嵌套Dialog场景中，将内层 Dialog 的该属性设置为 true，它就会插入至 body 元素上，从而保证内外层 Dialog 和遮罩层级关系的正确
    appendToBody: {
      type: Boolean,
      default: false,
    },
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Panel,
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
